import PropTypes from 'prop-types';
import React from 'react';

import { capitalize } from '../../lib/stringHelpers';
import SelectBase from '../SelectBase';
import SelectLoading from '../SelectLoading';
import SelectLoadingFail from '../SelectLoadingFail';

const SelectLoadingFetch = ({
  single,
  plural,
  onChange,
  selected,
  hook,
  fuseConfigKeys,
  getTerm,
  minCharSearchLength,
  label,
  hideEmpty,
  noOptionsMessage,
  displayError,
}) => {
  const { data, isLoading, error, reload, beforeStep } = hook();
  const capPlural = capitalize(plural);

  if (isLoading) {
    return (
      <div>
        <label className="desktop-d-helper">{label}</label>
        <SelectLoading prefix={`${capPlural} search`} />
      </div>
    );
  }
  if (error) {
    return (
      <div>
        <label className="desktop-d-helper">{label}</label>
        <SelectLoadingFail
          prefix={`Apologies! ${capPlural} search failed to load.`}
          suffix="Click to retry."
          onClick={reload}
        />
      </div>
    );
  }

  if (!data.length && hideEmpty) return '';

  return (
    <SelectBase
      selectedValue={selected}
      onChange={onChange}
      options={data}
      placeholder={`Search for your ${single}`}
      fuseConfigKeys={fuseConfigKeys}
      getTerm={getTerm}
      minCharSearchLength={minCharSearchLength}
      disabled={data.length === 0}
      label={label}
      noOptionsMessage={beforeStep?.value && !data.length && displayError ? noOptionsMessage : ''}
      displayError={beforeStep?.value && !data.length && displayError}
    />
  );
};

SelectLoadingFetch.propTypes = {
  single: PropTypes.string.isRequired,
  plural: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  hook: PropTypes.func.isRequired,
  fuseConfigKeys: PropTypes.arrayOf(PropTypes.string),
  getTerm: PropTypes.func,
  minCharSearchLength: PropTypes.number,
  label: PropTypes.string,
  hideEmpty: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  displayError: PropTypes.bool,
};

SelectLoadingFetch.defaultProps = {
  selected: null,
  fuseConfigKeys: ['label'],
  getTerm: () => {},
  minCharSearchLength: null,
  label: '',
  hideEmpty: false,
  noOptionsMessage: '',
  displayError: false,
};

export default SelectLoadingFetch;
